import "./newVehicle.css";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { addbikedetails } from "../../../Redux/actions/NumBikeation";
import {
  quick_quotes_Bike,
  QuickQuote_Post,
  Err_quotes,
} from "../../../Redux/actions/NumBikeation";
import { Form, Row, Col, Button, DatePicker, message, Select } from "antd/lib";
import moment from "moment";
import axiosInstance from "../../../Redux/axios/AxiosInstance";
// import _ from "lodash";
import "react-lazy-load-image-component/src/effects/blur.css";

export default function NewBikeedit({ setisModalBike }) {
  const bikenum = useSelector((state) => state?.vehicledetail?.bikenum);
  const vechicleData = useSelector((state) => state?.common?.vahanData);
  const auth = useSelector((state) => state.vehicledetail.bikenum);
  const postQuotes = useSelector(
    (state) => state?.vehicledetail?.quickQuotePost
  );
  const BikeMakeData = useSelector(
    (state) => state?.vehicledetail?.bikeMakeData
  );
  const [form] = Form.useForm();
  const [formLayout] = useState("vertical");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  // const [bikeNumDetail, setBikeNumdeail] = useState(bikenum);
  const [options, setOptions] = useState([]);
  const [MakeData, setMakeData] = useState([]);
  const [ModalData, setModalData] = useState([]);
  const [VarientData, setVarientData] = useState([]);
  const [Makeoptions, setMakeoptions] = useState([]);
  const [VarientOption, setVarientOptions] = useState([]);
  const [bikemake, setBikeMake] = useState(BikeMakeData?.make);
  const [bikemodel, setModelSearch] = useState(BikeMakeData?.model);
  const [rtoList, setrtoList] = useState([]);

  useEffect(() => {
    //console.log(bikeNumDetail)
    // form.setFieldsValue({
    //   BikeNumber: bikeNumDetail?.bike_number,
    //   manufacture: vechicleData?.registration_date
    //     ? moment(vechicleData?.registration_date)
    //     : null,
    // });
  }, [vechicleData, BikeMakeData]);

  useEffect(() => {
    axiosInstance
      .get(`vehicle_masters?no_of_wheels=2`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.makes;
        //console.log(resp);
        const makeData = resp.map((item) => item);
        // console.log("resp", makeData);
        setMakeoptions(makeData);
        setMakeData(makeData);
      })
      .catch((err) => {
        //console.log(err);
      });
  }, []);

  const onSelectMake = (data) => {
    //console.log("onSelect", data);
    setBikeMake(data);
    // setIsaveloading(false)
    form.setFieldsValue({
      bikeModel: "",
      bikeVarient: "",
    });
  };
  //console.log(bikemake)

  useEffect(() => {
    axiosInstance
      .get(`vehicle_masters?no_of_wheels=2&make=${bikemake}`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.models;
        //console.log(resp);
        const modelData = resp.map((item) => item);
        // console.log("resp", modelData);
        setOptions(modelData);
        setModalData(modelData);
      })
      .catch((err) => {
        console.log(err.response);
      });
  }, [bikemake]);

  const ModelChange = (e) => {
    setModelSearch(e);
    // setIsaveloading(false)
  };
  useEffect(() => {
    axiosInstance
      .get(`vehicle_masters?no_of_wheels=2&make=${bikemake}&model=${bikemodel}`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.variants;
        //console.log(resp);
        const varientData = resp.map((item) => item);
        // console.log("resp", varientData);
        setVarientOptions(resp);
        setVarientData(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [bikemodel]);

  const VarientChange = (variant, option) => {
    // console.log(variant,option)
    // setSelectVarient(variant)
    axiosInstance
      .get(
        `vehicle_masters?no_of_wheels=2&make=${bikemake}&model=${bikemodel}&variant=${variant}`
      )
      .then((res) => {
        const resp = res?.data;
        //console.log(resp);
        dispatch(
          addbikedetails({
            ...BikeMakeData,
            VehicleCoreCode: resp?.vehicle_core_code,
            customized_variant: option?.label,
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
    // setIsaveloading(false)
  };

  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const OnRtoChange = (rto) => {
    axiosInstance
      .get(`/rto_masters?rto_code=${rto}`)
      .then((res) => {
        const resp = res?.data;
        console.log(resp);
        setrtoList(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const OnSelectRto = (id, rto) => {
    dispatch(
      addbikedetails({
        ...BikeMakeData,
        selected_rto: rto?.label,
        selected_rto_id: id,
      })
    );
  };

  const disabledDate = (current) => {
    const currentYear = moment().year();
    const lastYear = currentYear - 1;
    return (
      current && current.year() !== currentYear && current.year() !== lastYear
    );
  };

  const onFinish = (data) => {
    console.log("data", data);
    const formattedDate = data.manufacture.format("YYYY");
    console.log("formattedDate", formattedDate);
    data.manufacture = formattedDate;
    dispatch(
      addbikedetails({
        ...BikeMakeData,
        make: data.bikeMake,
        model: data.bikeModel,
        year: data.manufacture,
        varbike: data.bikeVarient,
      })
    );
    // dispatch(addbikenum(bikeNumDetail));
    const updatedQuotePost = {
      ...postQuotes,
      year_of_manufacturing: data.manufacture,
      vehicle_core_code: BikeMakeData?.VehicleCoreCode,
      rto_code: BikeMakeData?.selected_rto,
    };
    console.log(updatedQuotePost);
    setLoading(true);
    axiosInstance
      .post(
        `bike_insurances/insurance_types/new/quick_quotes`,
        updatedQuotePost
      )
      .then((res) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          //console.log("data-----------------",data)
          const errData = data?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(Err_quotes(errData));
          const filteredData = data?.filter(
            (item) => "status" in item && item.status === "success"
          );
          //   const updatedData = filteredData?.map((item) => ({
          //     ...item,
          //     IsGst: true,
          //   }));
          //   dispatch(quick_quotes_Bike(updatedData));
          dispatch(quick_quotes_Bike(filteredData));
          dispatch(QuickQuote_Post(updatedQuotePost));
          setisModalBike(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err.response);
        setLoading(false);
        setisModalBike(false);
        message.error(err.response.data.message);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Form
        layout={formLayout}
        form={form}
        style={{ width: "100%" }}
        className="ant-quote-form col-xl-6 col-lg-6 col-md-6"
        requiredMark={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              name="Rto_Code"
              label="Select Rto"
              rules={[
                {
                  required: true,
                  message: "Please Select Variant",
                },
              ]}
              initialValue={BikeMakeData?.selected_rto}
            >
              <Select
                placeholder="Search for Rto"
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={rtoList?.map((p, index) => ({
                  key: index,
                  value: p.id,
                  label: p.rto_code,
                }))}
                onSearch={(rto) => OnRtoChange(rto)}
                onSelect={(id, rto) => OnSelectRto(id, rto)}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Manufacture Year"
              name="manufacture"
              rules={[
                {
                  required: true,
                  message: "please input Manufacture Year",
                },
              ]}
              initialValue={
                BikeMakeData?.year ? moment(BikeMakeData?.year) : null
              }
            >
              <DatePicker
                picker="year"
                style={{ width: "100%", padding: "8px" }}
                disabledDate={disabledDate}
                placeholder="Select Manufacture Year"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="bikeMake"
              label="Select Make"
              rules={[
                {
                  required: true,
                  message: "Please Select Make",
                },
              ]}
              initialValue={BikeMakeData?.make}
            >
              <Select
                placeholder="Select Make"
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={MakeData?.map((p, index) => ({
                  key: index,
                  value: p,
                  label: p,
                }))}
                // onChange={(e)=>onSelectMake(e)}
                onSelect={(e) => onSelectMake(e)}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="bikeModel"
              label="Select Model"
              rules={[
                {
                  required: true,
                  message: "Please Select Model",
                },
              ]}
              initialValue={BikeMakeData?.model}
            >
              <Select
                placeholder="Select Model"
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={ModalData?.map((p, index) => ({
                  key: index,
                  value: p,
                  label: p,
                }))}
                // onChange={(e)=>ModelChange(e)}
                onSelect={(e) => ModelChange(e)}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="bikeVarient"
              label="Select Variant"
              rules={[
                {
                  required: true,
                  message: "Please Select Variant",
                },
              ]}
              initialValue={BikeMakeData?.varbike}
            >
              <Select
                placeholder="Select Variant"
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={VarientData?.map((p, index) => ({
                  key: index,
                  value: p.variant,
                  label: p.customized_variant,
                }))}
                onChange={(variant, option) => VarientChange(variant, option)}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item {...buttonItemLayout}>
              <Button
                style={{ width: "100%" }}
                loading={loading}
                type="primary"
                htmlType="submit"
              >
                UPDATE
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}
